/**
 * Convert an ArrayBuffer containing image data to a data URL representing the image.
 * @param {ArrayBuffer} buffer - The ArrayBuffer containing the image data.
 * @param {string} [imageFormat="jpeg"] - The format of the image ("jpeg", "png", etc.).
 * @returns {string} A data URL representing the converted image.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return arraybufferToImage;
    }
});
function arraybufferToImage(buffer, imageFormat = "jpeg") {
    const mimeString = `image/${imageFormat}`;
    return URL.createObjectURL(new Blob([
        new Uint8Array(buffer)
    ], {
        type: mimeString
    }));
}
